const defaultProp = {
  selector: {
    width: '74',
  },
  expand: {
    width: '78',
  },
};

function getValidWidth(width) {
  let validWidth = width;

  if (typeof validWidth === 'string') {
    validWidth = validWidth.replace(/[^\d]/g, '');
  }

  validWidth = parseFloat(validWidth);

  if (isNaN(validWidth)) {
    validWidth = undefined;
  } else if (typeof width === 'string' && width.indexOf('%') > -1) {
    validWidth = validWidth / 100;
  }
  return validWidth;
}

function createColumn(vnode, options) {
  const column = {
    type: 'default',
    sortable: false,
    ...defaultProp[vnode.componentOptions.propsData.type],
    ...vnode.componentOptions.propsData,
  };

  column.validWidth = getValidWidth(column.width);
  column.validMinWidth = getValidWidth(column.minWidth);

  if (column.fixed === '' || column.fixed === true) {
    column.fixed = 'left';
  }

  if (!column.fixed) delete column.fixed;

  column.columnKey = column.columnKey || column.render || column.title;

  if (!column.order && options.sortInfo.column.columnKey === column.columnKey) {
    column.order = options.sortInfo.order || 'default';
  } else if (!column.order) {
    column.order = 'default';
  }

  if (vnode.componentOptions.propsData.sorter) {
    column.sortable = true;
  }

  // 兼容插槽的写法
  const _scopedSlots = vnode.data.scopedSlots;
  if (_scopedSlots) {
    if (_scopedSlots.default) column.renderCell = _scopedSlots.default;
    if (_scopedSlots.title) column.title = _scopedSlots.title;
  }
  return column;
}

export function getColumnsTree(vnodes, options) {
  return vnodes
    .map((vnode) => {
      if (vnode.tag && vnode.tag.indexOf('ten-table-column') > -1) {
        const column = createColumn(vnode, options);
        if (vnode.componentOptions.children) {
          column.children = getColumnsTree(
            vnode.componentOptions.children,
            options
          );
        }
        return column;
      }
      return undefined;
    })
    .filter(v => v);
}

export function traverseTree(tree, depth = 1, leaves) {
  return Math.max.apply(
    null,
    tree.map((_subTree) => {
      const subTree = _subTree;
      if (subTree.children) {
        if (subTree.fixed) {
          subTree.children.forEach((c) => {
            c.fixed = subTree.fixed; // eslint-disable-line
          });
        }
        const nowDepth = traverseTree(subTree.children, depth + 1, leaves);
        subTree.leafCount = subTree.children.reduce(
          (acc, cur) => acc + cur.leafCount,
          0
        );
        subTree.depth = nowDepth;
        return nowDepth;
      }
      subTree.leafCount = 1;
      subTree.isLeaf = true;
      subTree.depth = depth;
      leaves.push(subTree);
      return depth;
    })
  );
}

export function getColumnsTreeByProps(columns, options) {
  return columns.map((_column) => {
    let column = _column;
    column = {
      type: 'default',
      sortable: false,
      ...defaultProp[column.type],
      ...column,
    };
    column.validWidth = getValidWidth(column.width);
    column.validMinWidth = getValidWidth(column.minWidth);

    if (column.children) {
      column.children = getColumnsTreeByProps(column.children, options);
    }

    if (column.key) {
      column.render = column.key;
      delete column.key;
    }

    if (column.fixed === '' || column.fixed === true) {
      column.fixed = 'left';
    }

    if (!column.fixed) delete column.fixed;
    column.columnKey = column.columnKey || column.render || column.title;

    if (
      !column.order
      && options.sortInfo.column.columnKey === column.columnKey
    ) {
      column.order = options.sortInfo.order || 'default';
    } else if (!column.order) {
      column.order = 'default';
    }

    if (column.sorter) {
      column.sortable = true;
    }

    return column;
  });
}
